<div class="modal-header">
    <h5 class="modal-title text-center ml-auto mr-auto">{{ 'select_last_season_rank' | translate: lang }}</h5>
    <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
    </button>
</div>
<div class="modal-body">

    <div class="row">

        <div class="col-md text-center rank-select-item"
             (click)="onSelect(divisionService.getValueByRank('Unranked','tft'))">
            <img width="120" src="{{'https://cdn.ggboost.com/images/ranks/tft/'+
            divisionService.getValueByRank('Unranked','tft')+'.webp' | cdn}}"
                 alt="TFT Unranked Division">
            <div>Unranked</div>
        </div>

      <div class="col-md text-center rank-select-item"
           (click)="onSelect(divisionService.getValueByRank('Iron I','tft'))">
        <img width="120" src="{{'https://cdn.ggboost.com/images/ranks/tft/'+
            divisionService.getValueByRank('Iron I','tft')+'.webp' | cdn}}"
             alt="TFT Iron Division">
        <div>Iron</div>
      </div>

      <div class="col-md text-center rank-select-item"
           (click)="onSelect(divisionService.getValueByRank('Bronze I','tft'))">
        <img width="120" src="{{'https://cdn.ggboost.com/images/ranks/tft/'+
            divisionService.getValueByRank('Bronze I','tft')+'.webp' | cdn}}"
             alt="TFT Bronze Division">
        <div>Bronze</div>
      </div>

      <div class="col-md text-center rank-select-item"
           (click)="onSelect(divisionService.getValueByRank('Silver I','tft'))">
        <img width="120" src="{{'https://cdn.ggboost.com/images/ranks/tft/'+
            divisionService.getValueByRank('Silver I','tft')+'.webp' | cdn}}"
             alt="TFT Silver Division">
        <div>Silver</div>
      </div>

      <div class="col-md text-center rank-select-item"
           (click)="onSelect(divisionService.getValueByRank('Gold I','tft'))">
        <img width="120" src="{{'https://cdn.ggboost.com/images/ranks/tft/'+
            divisionService.getValueByRank('Gold I','tft')+'.webp' | cdn}}"
             alt="TFT Gold Division">
        <div>Gold</div>
      </div>

      <div class="col-md text-center rank-select-item"
           (click)="onSelect(divisionService.getValueByRank('Platinum I','tft'))">
        <img width="120" src="{{'https://cdn.ggboost.com/images/ranks/tft/'+
            divisionService.getValueByRank('Platinum I','tft')+'.webp' | cdn}}"
             alt="TFT Platinum Division">
        <div>Platinum</div>
      </div>

      <div class="col-md text-center rank-select-item"
           (click)="onSelect(divisionService.getValueByRank('Emerald I','tft'))">
        <img width="120" src="{{'https://cdn.ggboost.com/images/ranks/tft/'+
            divisionService.getValueByRank('Emerald I','tft')+'.webp' | cdn}}"
             alt="TFT Platinum Division">
        <div>Emerald</div>
      </div>

        <div class="col-md text-center">
          <img width="120" src="{{'https://cdn.ggboost.com/images/ranks/tft/'+
            divisionService.getValueByRank('Diamond I','tft')+'.webp' | cdn}}"
               alt="TFT Diamond Division">
          <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('Diamond IV','tft'))">Diamond IV</div>
          <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('Diamond III','tft'))">Diamond III</div>
          <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('Diamond II','tft'))">Diamond II</div>
          <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('Diamond I','tft'))">Diamond I</div>
        </div>

      <div class="col-md text-center rank-select-item"
           (click)="onSelect(divisionService.getValueByRank('Master','tft'))">
        <img width="120" src="{{'https://cdn.ggboost.com/images/ranks/tft/'+
            divisionService.getValueByRank('Master','tft')+'.webp' | cdn}}"
             alt="TFT Master Division">
        <div>Master</div>
      </div>

      <div class="col-md text-center rank-select-item"
           (click)="onSelect(divisionService.getValueByRank('Grandmaster','tft'))">
        <img width="120" src="{{'https://cdn.ggboost.com/images/ranks/tft/'+
            divisionService.getValueByRank('Grandmaster','tft')+'.webp' | cdn}}"
             alt="TFT Grandmaster Division">
        <div>Grandmaster</div>
      </div>
    </div>

</div>
